import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_holidays_summer: FaireCategoryEntity = {
  token: "cat_holidays-summer",
  type: "category",
  name: "Summer",
  level: 2,
  parentToken: "cat_holidays-seasonal",
  href: "/category/summer",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
